import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1300PerNrChangeStatus: 'idle',
    startProcess1300PerNrChangeError: undefined as any,
    loadUserParamsProcess1300PerNrChangeStatus: 'idle',
    loadUserParamsProcess1300PerNrChangeError: undefined as any,

    process1300PerNrChangeList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1300PerNrChange = createAsyncThunk('process1300PerNrChangeSlice/startProcess1300PerNrChange', async ({ process1300PerNrChange }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1300PerNrChange/`,
        prepareData(process1300PerNrChange),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1300PerNrChangeStatus } = getState().process1300PerNrChangeSlice
        return startProcess1300PerNrChangeStatus !== 'pending'
    }
})

export const loadUserParamsProcess1300PerNrChange = createAsyncThunk('process1300PerNrChangeSlice/loadUserParamsProcess1300PerNrChange', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1300PerNrChange/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1300PerNrChangeStatus } = getState().process1300PerNrChangeSlice
        return loadUserParamsProcess1300PerNrChangeStatus !== 'pending'
    }
})

const Process1300PerNrChangeSlice = createSlice({
    name: 'process1300PerNrChangeSlice',
    initialState,
    reducers: {
        resetstartProcess1300PerNrChange: (state) => {
            state.job = undefined
            state.startProcess1300PerNrChangeError = undefined
        },
        resetstartProcess1300PerNrChangeError: (state) => {
            state.startProcess1300PerNrChangeError = undefined
        },
        resetloadUserParamsProcess1300PerNrChange: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1300PerNrChangeError = undefined
        },
        resetloadUserParamsProcess1300PerNrChangeError: (state) => {
            state.loadUserParamsProcess1300PerNrChangeError = undefined
        },
        removeFromProcess1300PerNrChangeListById: (state, action) => {
            state.process1300PerNrChangeList = state.process1300PerNrChangeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1300PerNrChangeListByIds: (state, action) => {
            state.process1300PerNrChangeList = state.process1300PerNrChangeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1300PerNrChangeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1300PerNrChangeStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1300PerNrChangeList = []
            state.startProcess1300PerNrChangeStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1300PerNrChange.pending, (state) => {
            state.startProcess1300PerNrChangeStatus = 'pending'
            state.startProcess1300PerNrChangeError = undefined
        })
        builder.addCase(startProcess1300PerNrChange.fulfilled, (state, action) => {
            state.startProcess1300PerNrChangeStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1300PerNrChange.rejected, (state, action) => {
            state.startProcess1300PerNrChangeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1300PerNrChangeError = action.error.message
            } else {
                state.startProcess1300PerNrChangeError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1300PerNrChange.pending, (state) => {
            state.loadUserParamsProcess1300PerNrChangeStatus = 'pending'
            state.loadUserParamsProcess1300PerNrChangeError = undefined
        })
        builder.addCase(loadUserParamsProcess1300PerNrChange.fulfilled, (state, action) => {
            state.loadUserParamsProcess1300PerNrChangeStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1300PerNrChange.rejected, (state, action) => {
            state.loadUserParamsProcess1300PerNrChangeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1300PerNrChangeError = action.error.message
            } else {
                state.loadUserParamsProcess1300PerNrChangeError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1300PerNrChange,
    resetstartProcess1300PerNrChangeError,
    resetloadUserParamsProcess1300PerNrChange,
    resetloadUserParamsProcess1300PerNrChangeError,
    removeFromProcess1300PerNrChangeListById,
    removeFromProcess1300PerNrChangeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1300PerNrChangeSlice.actions
export default Process1300PerNrChangeSlice.reducer
